let tableResizer = {
    watch: {
        tableData: {
            deep: true,
            handler() {
                this.$nextTick(() => {
                    this.initResizers();
                    setTimeout(() => {
                        this.forceApplyColumnWidths();
                    }, 50);
                });
            }
        }
    },
    created() {
        this.forceApplyColumnWidths = function () {
            const table = this.$el && this.$el.querySelector('table');
            if (!table) return;

            const colgroup = table.querySelector('colgroup');
            if (!colgroup) return;

            const cols = colgroup.querySelectorAll('col');
            if (!cols.length) return;

            table.style.opacity = '0.99';
            setTimeout(() => {
                table.style.opacity = '1';
            }, 0);
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.initResizers();

            setTimeout(() => {
                this.forceApplyColumnWidths();
            }, 100);
        });
    },
    beforeDestroy() {
        this.cleanupResizers();
    },
    methods: {
        saveColumnWidths(columnWidths) {
            if (!this.$options.name) return;

            try {
                localStorage.setItem(`table-widths-${this.$options.name}`, JSON.stringify(columnWidths));
            } catch (e) {
                console.error('Failed to save column widths to localStorage:', e);
            }
        },

        loadColumnWidths() {
            if (!this.$options.name) return null;

            try {
                const savedWidths = localStorage.getItem(`table-widths-${this.$options.name}`);
                return savedWidths ? JSON.parse(savedWidths) : null;
            } catch (e) {
                console.error('Failed to load column widths from localStorage:', e);
                return null;
            }
        },
        detectButtonColumns() {
            const table = this.$el.querySelector('table');
            if (!table) {
                return [];
            }

            const tbody = table.querySelector('tbody');
            if (!tbody) {
                return [];
            }

            const rows = tbody.querySelectorAll('tr');
            if (!rows.length) {
                return [];
            }

            const columnCount = rows[0].querySelectorAll('td').length;
            const buttonCounts = Array(columnCount).fill(0);
            const cellCounts = Array(columnCount).fill(0);

            rows.forEach(row => {
                const cells = row.querySelectorAll('td');
                cells.forEach((cell, index) => {
                    if (index < columnCount) {
                        cellCounts[index]++;

                        const btnContainer = cell.querySelector('.holder-btns');
                        if (btnContainer) {
                            const buttons = btnContainer.querySelectorAll('button, .btn');
                            if (buttons.length) {
                                buttonCounts[index]++;
                            }
                        } else {

                            const buttons = cell.querySelectorAll('button, .btn');
                            if (buttons.length) {
                                buttonCounts[index]++;
                            }
                        }
                    }
                });
            });

            const buttonColumns = [];
            buttonCounts.forEach((count, index) => {
                if (cellCounts[index] > 0 && count / cellCounts[index] > 0.5) {
                    buttonColumns.push(index);
                }
            });

            return buttonColumns;
        },

        applyButtonColumnStyles(buttonColumns) {
            const table = this.$el.querySelector('table');
            if (!table || !buttonColumns.length) {
                return;
            }

            const tbody = table.querySelector('tbody');
            if (!tbody) {
                return;
            }


            const lastColumnIndex = buttonColumns[buttonColumns.length - 1];
            if (lastColumnIndex !== undefined) {
                const lastHeader = table.querySelectorAll('th')[lastColumnIndex];
                if (lastHeader) {
                    lastHeader.style.zIndex = '5';
                    lastHeader.style.position = 'relative';
                }
            }

            const rows = tbody.querySelectorAll('tr');
            rows.forEach(row => {
                const cells = row.querySelectorAll('td');
                buttonColumns.forEach(colIndex => {
                    if (cells[colIndex]) {
                        const cell = cells[colIndex];

                        cell.style.textAlign = 'right';

                        const btnContainer = cell.querySelector('.holder-btns');
                        if (btnContainer) {
                            btnContainer.style.display = 'flex';
                            btnContainer.style.justifyContent = 'flex-end';
                            btnContainer.style.gap = '10px';
                            btnContainer.style.flexWrap = 'nowrap';
                            btnContainer.style.alignItems = 'center';
                            btnContainer.style.minWidth = 'fit-content';
                        }

                        const buttons = cell.querySelectorAll('button, .btn');
                        buttons.forEach(btn => {
                            btn.style.flexShrink = '0';
                            btn.style.minWidth = 'fit-content';
                            btn.style.whiteSpace = 'nowrap';
                        });
                    }
                });
            });
        },
        initResizers() {
            const table = this.$el.querySelector('table');
            if (!table) {
                return;
            }

            const allCells = table.querySelectorAll('td, th');
            allCells.forEach(cell => {
                cell.style.overflow = 'hidden';
                cell.style.boxSizing = 'border-box';
            });

            const tableContainer = this.$el.querySelector('.table-container');
            if (!tableContainer) {
                return;
            }

            const containerRect = tableContainer.getBoundingClientRect();
            const fixedContainerWidth = Math.min(containerRect.width, window.innerWidth - 80);

            tableContainer.style.width = `${fixedContainerWidth}px`;
            tableContainer.style.maxWidth = `${fixedContainerWidth}px`;
            tableContainer.style.minWidth = `${fixedContainerWidth}px`;
            tableContainer.style.flexShrink = '0';
            tableContainer.style.flexGrow = '0';

            table.style.tableLayout = 'fixed';
            table.style.minWidth = '100%';

            this.cleanupResizers();

            const thList = table.querySelectorAll('th');

            const columnWidths = [];
            const columnMinWidths = [];
            let totalTableWidth = 0;

            const savedWidths = this.loadColumnWidths();

            if (savedWidths) {
                table.style.opacity = '0.99';
                setTimeout(() => {
                    table.style.opacity = '1';
                }, 0);
            }

            thList.forEach((th, thIndex) => {
                const rect = th.getBoundingClientRect();

                const computedWidth = rect.width;
                columnWidths[thIndex] = savedWidths && savedWidths[thIndex] ? savedWidths[thIndex] : computedWidth;
                totalTableWidth += columnWidths[thIndex];

                let minWidth = 50;

                const contentElement = th.querySelector('.table-header-box, .custom-checkbox-group, .holder-deactivate-btn');
                if (contentElement) {
                    const buttonElement = contentElement.querySelector('button, .btn');

                    if (buttonElement) {
                        const buttonRect = buttonElement.getBoundingClientRect();
                        const buttonWidth = buttonRect.width;

                        minWidth = Math.max(buttonWidth + 20, 100);

                    } else {
                        const tempElement = document.createElement('div');
                        tempElement.style.position = 'absolute';
                        tempElement.style.visibility = 'hidden';
                        tempElement.style.whiteSpace = 'nowrap';
                        tempElement.style.fontSize = window.getComputedStyle(contentElement).fontSize;
                        tempElement.style.fontFamily = window.getComputedStyle(contentElement).fontFamily;
                        tempElement.style.fontWeight = window.getComputedStyle(contentElement).fontWeight;

                        const textElement = contentElement.querySelector('.header-table-text, .btn-span');
                        if (textElement) {
                            tempElement.textContent = textElement.textContent.trim();
                        } else {
                            tempElement.textContent = contentElement.textContent.trim();
                        }

                        document.body.appendChild(tempElement);
                        const textWidth = tempElement.offsetWidth;
                        document.body.removeChild(tempElement);

                        minWidth = Math.max(textWidth + 80, 50);
                    }
                }

                const tbody = table.querySelector('tbody');
                if (tbody) {
                    const firstRow = tbody.querySelector('tr');
                    if (firstRow) {
                        const cells = firstRow.querySelectorAll('td');
                        if (cells[thIndex]) {
                            if (thIndex === cells.length - 1) {
                                const btnContainer = cells[thIndex].querySelector('.holder-btns');
                                if (btnContainer) {
                                    let totalButtonsWidth = 0;
                                    const allButtons = btnContainer.querySelectorAll('button, .btn');
                                    allButtons.forEach(btn => {
                                        totalButtonsWidth += btn.getBoundingClientRect().width;
                                    });

                                    if (allButtons.length > 1) {
                                        totalButtonsWidth += 10 * (allButtons.length - 1);
                                    }

                                    const requiredWidth = totalButtonsWidth + 30;
                                    minWidth = Math.max(minWidth, requiredWidth);

                                    btnContainer.style.minWidth = `${requiredWidth}px`;
                                } else {
                                    const cellButtons = cells[thIndex].querySelectorAll('button, .btn');
                                    if (cellButtons.length > 0) {
                                        let maxButtonWidth = 0;
                                        cellButtons.forEach(btn => {
                                            const btnRect = btn.getBoundingClientRect();
                                            maxButtonWidth = Math.max(maxButtonWidth, btnRect.width);
                                        });

                                        if (maxButtonWidth > 0) {
                                            const dataRowMinWidth = maxButtonWidth * cellButtons.length + 30;
                                            minWidth = Math.max(minWidth, dataRowMinWidth);
                                        }
                                    }
                                }
                            } else {
                                const cellButtons = cells[thIndex].querySelectorAll('button, .btn');
                                if (cellButtons.length > 0) {
                                    let maxButtonWidth = 0;
                                    cellButtons.forEach(btn => {
                                        const btnRect = btn.getBoundingClientRect();
                                        maxButtonWidth = Math.max(maxButtonWidth, btnRect.width);
                                    });

                                    if (maxButtonWidth > 0) {
                                        const dataRowMinWidth = maxButtonWidth + 30;
                                        minWidth = Math.max(minWidth, dataRowMinWidth);
                                    }
                                }
                            }
                        }
                    }
                }

                columnMinWidths[thIndex] = minWidth;

                th.style.width = `${computedWidth}px`;
                th.style.minWidth = `${computedWidth}px`;
                th.style.maxWidth = `${computedWidth}px`;
                th.style.boxSizing = 'border-box';
            });

            let colgroup = table.querySelector('colgroup');
            if (!colgroup) {
                colgroup = document.createElement('colgroup');
                table.insertBefore(colgroup, table.firstChild);
            }
            colgroup.innerHTML = '';

            columnWidths.forEach((width) => {
                const col = document.createElement('col');
                col.style.width = `${width}px`;
                col.style.minWidth = `${width}px`;
                col.style.maxWidth = `${width}px`;
                colgroup.appendChild(col);
            });

            table.style.width = `${totalTableWidth}px`;
            table.style.minWidth = `${totalTableWidth}px`;

            const buttonColumns = this.detectButtonColumns();
            this.applyButtonColumnStyles(buttonColumns);

            const aggressiveLockAllColumns = () => {
                if (!colgroup || !table) return;

                const cols = colgroup.querySelectorAll('col');
                if (!cols.length) return;

                cols.forEach((col, colIndex) => {
                    const width = columnWidths[colIndex];
                    col.style.width = `${width}px`;
                    col.style.minWidth = `${width}px`;
                    col.style.maxWidth = `${width}px`;
                });

                thList.forEach((th, thIndex) => {
                    const width = columnWidths[thIndex];
                    th.style.width = `${width}px`;
                    th.style.minWidth = `${width}px`;
                    th.style.maxWidth = `${width}px`;
                });

                tableContainer.style.width = `${fixedContainerWidth}px`;
                tableContainer.style.maxWidth = `${fixedContainerWidth}px`;
                tableContainer.style.minWidth = `${fixedContainerWidth}px`;

                table.offsetHeight;
                table.offsetWidth;
            };

            table.offsetHeight;
            table.offsetWidth;
            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                    aggressiveLockAllColumns();
                });
            });

            setTimeout(() => {

                const self = this;

                thList.forEach((th, resizeIndex) => {
                    if (th.classList.contains('holder-checkbox')) {
                        return;
                    }

                    const resizer = document.createElement('div');
                    resizer.classList.add('resizer');
                    resizer.style.position = 'absolute';
                    resizer.style.top = '0';
                    resizer.style.right = '0';
                    resizer.style.width = '8px';
                    resizer.style.height = '100%';
                    resizer.style.cursor = 'col-resize';
                    resizer.style.userSelect = 'none';
                    resizer.style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
                    resizer.style.zIndex = '3';
                    resizer.style.borderLeft = '1px solid rgba(0, 0, 0, 0.2)';
                    resizer.style.display = 'block';
                    resizer.style.opacity = '1';
                    resizer.style.visibility = 'visible';
                    resizer.style.pointerEvents = 'all';

                    const mouseDownHandler = function (e) {
                        e.preventDefault();
                        e.stopPropagation();

                        aggressiveLockAllColumns();

                        const initialWidth = columnWidths[resizeIndex];
                        const startX = e.clientX;
                        const resizerRect = resizer.getBoundingClientRect();
                        const thRect = th.getBoundingClientRect();
                        const columnMinWidth = columnMinWidths[resizeIndex];

                        if (initialWidth < columnMinWidth) {
                            columnWidths[resizeIndex] = columnMinWidth;
                            aggressiveLockAllColumns();

                            const correctedThRect = th.getBoundingClientRect();
                            thRect.left = correctedThRect.left;
                            thRect.right = correctedThRect.right;
                            thRect.width = correctedThRect.width;
                        }

                        const absoluteMinLeft = thRect.left + columnMinWidth;

                        const dragResizer = document.createElement('div');
                        dragResizer.classList.add('resizer', 'drag-resizer');

                        resizer.style.opacity = '0';
                        resizer.style.visibility = 'hidden';

                        dragResizer.style.position = 'fixed';
                        dragResizer.style.width = '8px';
                        dragResizer.style.height = resizerRect.height + 'px';
                        dragResizer.style.backgroundColor = 'var(--accent-color)';
                        dragResizer.style.borderLeft = '1px solid var(--accent-color)';
                        dragResizer.style.zIndex = '999999';
                        dragResizer.style.boxShadow = '0 0 5px rgba(0, 0, 0, 0.5)';
                        dragResizer.style.cursor = 'col-resize';
                        dragResizer.style.top = resizerRect.top + 'px';
                        dragResizer.style.left = (resizerRect.left < absoluteMinLeft ? absoluteMinLeft : resizerRect.left) + 'px';

                        document.body.appendChild(dragResizer);

                        document.addEventListener('mousemove', mouseMoveHandler);
                        document.addEventListener('mouseup', mouseUpHandler);

                        resizer.classList.add('resizing');

                        function mouseMoveHandler(e) {
                            e.preventDefault();
                            e.stopPropagation();

                            const deltaX = e.clientX - startX;
                            let newWidth = initialWidth + deltaX;

                            const absoluteMinWidth = columnMinWidths[resizeIndex];
                            if (newWidth < absoluteMinWidth) {
                                newWidth = absoluteMinWidth;
                            }


                            const tableWidth = table.getBoundingClientRect().width;
                            const lastColumnIndex = thList.length - 1;
                            const lastCellWidth = columnWidths[lastColumnIndex];


                            if (resizeIndex < lastColumnIndex) {
                                const maxAvailableWidth = tableWidth - lastCellWidth - 20;


                                let otherColumnsWidth = 0;
                                for (let i = 0; i < columnWidths.length; i++) {
                                    if (i !== resizeIndex && i !== lastColumnIndex) {
                                        otherColumnsWidth += columnWidths[i];
                                    }
                                }


                                const maxWidthForCurrentColumn = maxAvailableWidth - otherColumnsWidth;
                                if (newWidth > maxWidthForCurrentColumn) {
                                    newWidth = maxWidthForCurrentColumn;
                                }
                            }

                            const tbody = table.querySelector('tbody');
                            if (tbody) {
                                const rows = tbody.querySelectorAll('tr');
                                let maxButtonContainerWidth = 0;

                                rows.forEach(row => {
                                    const cells = row.querySelectorAll('td');
                                    if (cells[resizeIndex]) {

                                        const btnContainer = cells[resizeIndex].querySelector('.holder-btns');
                                        if (btnContainer) {

                                            let totalButtonsWidth = 0;
                                            const allButtons = btnContainer.querySelectorAll('button, .btn');

                                            allButtons.forEach(btn => {

                                                const btnRect = btn.getBoundingClientRect();
                                                totalButtonsWidth += btnRect.width;
                                            });

                                            if (allButtons.length > 1) {
                                                totalButtonsWidth += 10 * (allButtons.length - 1);
                                            }

                                            const containerWidth = totalButtonsWidth + 30;
                                            maxButtonContainerWidth = Math.max(maxButtonContainerWidth, containerWidth);
                                        } else {

                                            const directButtons = cells[resizeIndex].querySelectorAll('button, .btn');
                                            if (directButtons.length > 0) {
                                                let totalDirectButtonWidth = 0;

                                                directButtons.forEach(btn => {
                                                    const btnRect = btn.getBoundingClientRect();
                                                    totalDirectButtonWidth += btnRect.width;
                                                });

                                                if (directButtons.length > 1) {
                                                    totalDirectButtonWidth += 10 * (directButtons.length - 1);
                                                }

                                                const directButtonsWidth = totalDirectButtonWidth + 30;
                                                maxButtonContainerWidth = Math.max(maxButtonContainerWidth, directButtonsWidth);
                                            }
                                        }
                                    }
                                });

                                if (maxButtonContainerWidth > 0 && newWidth < maxButtonContainerWidth) {
                                    newWidth = maxButtonContainerWidth;
                                }
                            }

                            const absoluteMinLeft = thRect.left + absoluteMinWidth;
                            let newResizerLeft = thRect.left + newWidth;

                            if (newResizerLeft < absoluteMinLeft) {
                                newResizerLeft = absoluteMinLeft;
                                newWidth = absoluteMinWidth;
                            }

                            const dragResizer = document.querySelector('.drag-resizer');

                            const widthDifference = newWidth - columnWidths[resizeIndex];

                            if (Math.abs(widthDifference) > 0.1) {
                                columnWidths[resizeIndex] = newWidth;

                                aggressiveLockAllColumns();

                                totalTableWidth += widthDifference;
                                table.style.width = `${totalTableWidth}px`;
                                table.style.minWidth = `${totalTableWidth}px`;

                                aggressiveLockAllColumns();

                                const buttonColumns = self.detectButtonColumns();
                                self.applyButtonColumnStyles(buttonColumns);
                            }

                            if (dragResizer) {
                                dragResizer.style.left = newResizerLeft + 'px';

                                if (newResizerLeft < absoluteMinLeft) {
                                    dragResizer.style.left = absoluteMinLeft + 'px';
                                }


                                const lastColumnRect = thList[lastColumnIndex].getBoundingClientRect();
                                const maxLeft = lastColumnRect.left - 10;
                                if (newResizerLeft > maxLeft && resizeIndex < lastColumnIndex) {
                                    dragResizer.style.left = maxLeft + 'px';
                                    newWidth = maxLeft - thRect.left;
                                    columnWidths[resizeIndex] = newWidth;
                                }

                                dragResizer.style.zIndex = '999999';
                                dragResizer.style.visibility = 'visible';
                                dragResizer.style.opacity = '1';
                            }
                        }

                        function mouseUpHandler() {
                            document.removeEventListener('mousemove', mouseMoveHandler);
                            document.removeEventListener('mouseup', mouseUpHandler);

                            const finalWidth = Math.max(columnWidths[resizeIndex], columnMinWidth);
                            columnWidths[resizeIndex] = finalWidth;
                            aggressiveLockAllColumns();

                            self.saveColumnWidths(columnWidths);

                            const dragResizer = document.querySelector('.drag-resizer');
                            if (dragResizer && dragResizer.parentNode) {
                                dragResizer.parentNode.removeChild(dragResizer);
                            }

                            resizer.style.position = 'absolute';
                            resizer.style.right = '0';
                            resizer.style.left = 'auto';
                            resizer.style.top = '0';
                            resizer.style.height = '100%';
                            resizer.style.zIndex = '3';
                            resizer.style.opacity = '1';
                            resizer.style.visibility = 'visible';

                            resizer.offsetHeight;

                            resizer.classList.remove('resizing');
                            resizer.style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
                            resizer.style.borderLeft = '1px solid rgba(0, 0, 0, 0.2)';
                            resizer.style.boxShadow = 'none';
                            resizer.style.width = '8px';
                        }
                    };

                    resizer.addEventListener('mousedown', mouseDownHandler);
                    resizer._mouseDownHandler = mouseDownHandler;
                    th.appendChild(resizer);
                });
            }, 0);
        },
        cleanupResizers() {
            const table = this.$el && this.$el.querySelector('table');
            if (!table) {
                return;
            }

            const dragResizer = document.querySelector('.drag-resizer');
            if (dragResizer && dragResizer.parentNode) {
                dragResizer.parentNode.removeChild(dragResizer);
            }

            const resizers = table.querySelectorAll('.resizer');

            resizers.forEach((resizer) => {
                if (resizer._mouseDownHandler) {
                    resizer.removeEventListener('mousedown', resizer._mouseDownHandler);
                }

                if (resizer.parentNode) {
                    resizer.parentNode.removeChild(resizer);
                }
            });
        }
    }
};

export default tableResizer;
